import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useMediaQuery } from '@mui/material';
import * as React from 'react';
import { format } from 'react-string-format';
import { MyMLabel } from '../ui-elements/MyMLabel';

export const Pager = (props) => {
  const { resultListItem, pageNumber, handleChangePage, labelList, ...other } = props;
  const count = Math.ceil(resultListItem.TotalRecordCount / resultListItem.PageDisplayCount);
  const isMobile = useMediaQuery('(max-width:430px)');
  const isTablet = useMediaQuery('(max-width:768px)');

  return (
    <Table sx={{ border: 0, 'td': { border: 0, padding: '2px' } }}>
      <TableBody>
        
        {isMobile
          ? (
            <>
              <TableRow>
                <TableCell sx={{ maxWidth: '170px', width: '10px' }}>
                  <MyMLabel>{labelList.lblTotalNumberTitle} {resultListItem.TotalRecordCount}</MyMLabel>
                </TableCell>
                </TableRow>
                <TableRow>
                <TableCell sx={{ maxWidth: '170px', width: '50px' }}>
                  <MyMLabel>{format(labelList.lblPageOf, resultListItem.TotalRecordCount === 0 ? 0 : pageNumber, count)}</MyMLabel>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={1} sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                  <Box
                    align='left'
                    bottom='0px'
                    className='d-flex align-items-center'
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <Pagination
                      count={count}
                      page={pageNumber}
                      color={'primary'}
                      onChange={(_, page) => handleChangePage(page)}
                      showFirstButton
                      showLastButton
                      siblingCount={0} 
                      boundaryCount={0} 
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                      {...other}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            </>
          ):(
            <>
              <TableRow>
                <TableCell sx={{ maxWidth: isTablet ? '200px':'170px' }}>
                <MyMLabel>{labelList.lblTotalNumberTitle} {resultListItem.TotalRecordCount}</MyMLabel>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <MyMLabel>{format(labelList.lblPageOf, resultListItem.TotalRecordCount === 0 ? 0 : pageNumber, count)}</MyMLabel>
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', overflowX: 'auto' }}>
                  <Box align='left' bottom='0px' className='d-flex align-items-center' justifyContent= {isTablet ? 'start' : 'center'} sx={{ width: isTablet?'100%': '60%' }}>
                    <Pagination
                      count={count}
                      page={pageNumber}
                      color={'primary'}
                      onChange={(_, page) => handleChangePage(page)}
                      showFirstButton
                      showLastButton
                      siblingCount={isTablet ? 0 : 1}
                      boundaryCount={1}
                      sx={{
                        '.MuiPaginationItem-text': {
                          fontSize: '1rem',
                        },
                      }}
                      {...other}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            </>
        )}
      </TableBody>
    </Table>
  );
};
